var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"opacity":"0.7"}},[_c('v-progress-circular',{attrs:{"size":"70","width":"7","indeterminate":"","color":"primary"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }